export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'COMPANY_FOLLOW_TEMPLATE',
        data => ({
            id: data.companyId,
            followId: data.id,
            userId: data.userId,
        }),
    ],

    GET: {
        authorize: true,
    },

    POST: {
        authorize: true,
    },

    '/:id': {
        DELETE: {},
    },
};
